import { ReactElement } from 'react';
import { useTheme } from '@mui/material';

import { IChartPoint } from '../useStakingChart';

export interface IActiveDotProps {
  cx?: number;
  cy?: number;
  payload?: IChartPoint;
}

export function ActiveDot(props: IActiveDotProps): ReactElement | null {
  const { cx, cy, payload } = props;
  const { palette } = useTheme();

  if (!cx || !cy || payload?.isEdge || payload?.value === null) {
    return null;
  }

  return (
    <svg height={12} viewBox="0 0 12 12" width={12} x={cx - 6} y={cy - 6}>
      <circle cx="6" cy="6" fill={palette.primary.main} r="6" />
    </svg>
  );
}
